import { render, staticRenderFns } from "./myShopPay.vue?vue&type=template&id=c9e720ce&scoped=true"
import script from "./myShopPay.vue?vue&type=script&lang=js"
export * from "./myShopPay.vue?vue&type=script&lang=js"
import style0 from "./myShopPay.vue?vue&type=style&index=0&id=c9e720ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e720ce",
  null
  
)

export default component.exports